module.exports = __webpack_public_path__ + "static/media/brinks_products.99d741f1.png";